import { observer } from 'mobx-react';
import { store } from '../Store';
import { Hotspots } from './Hotspots';
import { LoadingOverlay } from './LoadingOverlay';
import SceneViewerContainer from './SceneViewerContainer';
import { Logo } from './Logo';
import { MenuButton } from './MenuButton';
import { Menu } from './Menu';
import { HotspotPanel } from './HotspotPanel';

import './App.css';
import { reaction } from 'mobx';
import { useState } from 'react';
import classNames from 'classnames';

const App = observer((props) => {

  const [ hotspotsAvailable, setHotspotsAvailable ] = useState(false); 
  const hotspotData = props.content.hotspots;
  
  reaction(() => store.started, async (started, wasStarted) => {
    if (started && !wasStarted) {
      setTimeout(() => {
        setHotspotsAvailable(true);
      }, 2500);
    }
  });

  return (
    <div className={classNames("App", { "mobile" : window.MOBILE })}>
      <Logo white={store.started} />

      <MenuButton visible={store.started} />

      <LoadingOverlay visible={!store.started} content={props.content} />

      <Menu content={props.content} />
      
      <Hotspots 
        visible={hotspotsAvailable && store.currentHotspotId === null}
        data={hotspotData} 
      />

      <HotspotPanel
        data={hotspotData}
        visible={store.hotspotPanelVisible}
      />
      
      <SceneViewerContainer />
    </div>
  );
});

export default App;
